import styled from 'styled-components'
import Image from 'next/legacy/image'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import useViewportHeight from 'hooks/use-viewport-height'

const OnDeployStyled = styled.div`
  h1 {
    max-width: 700px;
    margin: 0 auto;
  }
  .deployment-container {
    block-size: ${({ height }) => height};
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 700px;
    margin: 0 auto;
  }
  .deploy-img {
    margin: 0 auto;
    width: fit-content;
  }
  @media(min-width: 1024px) {
    .deployment-container {
      block-size: calc(100vh - var(--headerBlockSize)) !important;
    }
  }
`

function OnDeploy() {
  const viewportHeight = useViewportHeight()
  return (
    <OnDeployStyled height={viewportHeight}>
      <Wrapper>
        <div className="deployment-container">
          <div className="deploy-img">
            <Image
              className="deployment-img"
              width={600}
              height={411}
              src="/images/errors/deploy_ilustration.png"
              alt="Ilustracion de una chica forjando una medalla"
            />
          </div>
          <Typography as="h1" font="headline5" align="center">
            Nos encontrando realizando tareas de mantenimiento.
          </Typography>
          <Typography as="h1" font="headline5" align="center">
            Vuelve en 5 minutos.
          </Typography>
        </div>
      </Wrapper>
    </OnDeployStyled>
  )
}

export default OnDeploy
